<form-input-regex
  id="txtEmail"
  inputmode="email"
  [(ngModel)]="value"
  (ngModelChange)="onChange()"
  #email="ngModel"
  type="email"
  [regex]="regexEmail"
  [regexInput]="regexEmailInput"
  [hasTwoRegex]="true"
  [label]="label"
  [required]="required"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [iconCheck]="iconCheck"
  [iconBlock]="iconBlock"
  [hasError]="hasError"
></form-input-regex>
